import { useEffect, useState } from 'react';

export type DisplayMode = 'native' | 'standalone' | 'browser';

const readMode = (): DisplayMode => {
  if (typeof window === 'undefined') return 'browser';
  // Inside the Capacitor iOS/Android WebView we're already running as a native
  // app — no install-prompt UI should render.
  if ((window as unknown as { Capacitor?: unknown }).Capacitor) return 'native';
  if (window.matchMedia('(display-mode: standalone)').matches) return 'standalone';
  // Safari on iOS uses navigator.standalone instead of the display-mode media query.
  if ((window.navigator as unknown as { standalone?: boolean }).standalone) return 'standalone';
  return 'browser';
};

export const useDisplayMode = (): DisplayMode => {
  const [mode, setMode] = useState<DisplayMode>(readMode);

  useEffect(() => {
    const mql = window.matchMedia('(display-mode: standalone)');
    const handler = () => setMode(readMode());
    mql.addEventListener?.('change', handler);
    return () => mql.removeEventListener?.('change', handler);
  }, []);

  return mode;
};
